export default "__VITE_ASSET__c254d488__"